import React from "react";
import {withTranslation} from "react-i18next";
import BetRQ from "./betModel";
import PNotify from "pnotify/dist/es/PNotify";
import {
    getMulti,
    getNormalRange,
    getNotPair,
    getPair, getSpecialRange, specialTripleX,
} from "../../utils/BetCalculateUtils";
import swal from "sweetalert";
import _ from "lodash";
import ReactToPrint from "react-to-print";
import {showErrorMessage} from "./showErrorMessage";
import {getAutoPrint} from "../../utils/Print";
import {clientAp} from "../../constants/general";
import {betTypes, multiples, post, SUBSCRIPTION_Lo5D} from "../../constants/lotto5d";
import {KEY_CODE} from "../../constants/Key";
import {ERROR_LOADING} from "../../store/lotto5d/types";
import {Ticket58} from "./ticket/ticket58";
import {getDateDef} from "../../utils/dateUtils";
import {getUser} from "../../utils/cached";
import {fetchUserBalance, getRecentSize} from "../../store/user/action";
import {Lotto5dContext} from "../../store/lotto5d/Lotto5dContext";
import {connect} from "react-redux";
import {
    fetchBetting,
    fetchCurrentDraw5D, fetchLotto5dRecentTicket,
    fetchPaging,
    fetchResults,
    postBetting, setLoading,
    updateBet
} from "../../store/lotto5d/action";
import {playAudio} from "../../store/audio/action";

const initState = {
    isFocus: false,
    isRow: false,
    isEdit: false,
    currentTicket: 1,
};


class MainDrawingWrapper extends React.Component {
    constructor(props) {
        super(props);
        const filters = this.props.sale.filters;
        this.state = {
            filters: filters ? {...filters} : {...initState},
            isFocus: false,
            lastDraws: [],
            isSelected: null,
            autoPrint: true,
            isBetting: false,
            focusIndex: 0,
            disabled: false,
            isDeletePage: false,
            eventBus: undefined,
            posts: [...post],
            betTypes: {
                betType: [...betTypes],
                activeBetTypeId: "NORMAL",
            },
            pairStatus: 0,
            multiples: [...multiples],
            selectedMulti: false,
            currency: getUser()?.currencyCode,
            isMulti: false,
            specBetCheck: null,
            graveKey: false,
            fields: {
                betAmount: 0,
                multiDigit: null,
                numberFrom: "",
                numberTo: "",
                numberThree: "",
                numberFour: "",
            },
            currentBetting: {
                postGroup: [],
                totalUsd: 0,
                totalKhr: 0,
            }, data: props.sale.data, isRow: props.isRow, isLockBet: false,
            isSelectFrom: false,
            isSelectTo: false,
            isBetAmount: false,
            status: null,
        };
        this.handleBetTypeCheckChange = this.handleBetTypeCheckChange.bind(this);
        this.handlePostCheckChange = this.handlePostCheckChange.bind(this);
        this.handleCurrencyCheckChange = this.handleCurrencyCheckChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleDigitKeyPress = this.handleDigitKeyPress.bind(this);
        this.focusInputAmount = this.focusInputAmount.bind(this);
        this.unFocusInputAmount = this.unFocusInputAmount.bind(this);
        this.onDeleteItem = this.onDeleteItem.bind(this);

        this.firstDigitInput = React.createRef();
        this.twoDigitInput = React.createRef();
        this.threeDigitInput = React.createRef();
        this.fourDigitInput = React.createRef();
        this.amountDigitInput = React.createRef();
        this.componentRef = React.createRef();

    }

    componentDidMount() {
        this.subscription();
        this.refreshData();
        window.addEventListener("keydown", this.handleKeyDown);
        this.setState({autoPrint: getAutoPrint()});
        document.addEventListener("visibilitychange", this.handleTabChange);
    }

    onDrawStatusChange = (currentDraw) => {
        if (currentDraw.status !== this.state.status) {
            if (currentDraw.status === "OPEN" && this.state.status) {
                this.refreshData();
            }
            if (currentDraw.status === "RELEASE") this.props.fetchCurrentDraw5D();
            this.setState({status: currentDraw.status});
        }
    }

    refreshData = () => {
        this.props.fetchCurrentDraw5D();
        this.props.fetchResults({filterByDate: getDateDef()});
        this.props.fetchUserBalance();
        this.props.fetchLotto5dRecentTicket({size: getRecentSize().lo5d});
    }

    handleTabChange() {
        if (document.hidden) {
        } else {
            let doc = document.getElementById("refresh-draw");
            doc && doc.click()
        }
    }

    componentWillUnmount() {
        this.drawSubscription && this.drawSubscription.unsubscribe();
        this.removeListener();
    }


    subscription = () => {
        this.drawSubscription = clientAp.subscribe({
            query: SUBSCRIPTION_Lo5D,
        }).subscribe({
            next: (event) => {
                if (event.data && event.data.v_lotto5d_drawing) {
                    let currentDraw = event.data.v_lotto5d_drawing[0] || {};
                    this.onDrawStatusChange(currentDraw);
                }
            },
            error: (err) => {
                console.error("err", err);
            }
        });
    };


    componentDidUpdate(prevProps, prevState, snapshot) {
        /* update props when prevProps changed */
        if (prevProps !== this.props) {
            this.setState(() => ({
                prevProps: this.props,
            }));
        }

        if (prevState.isFocus !== this.state.isFocus) {
            if (!this.state.isFocus)
                window.addEventListener("keydown", this.handleKeyDown);
            else window.removeEventListener("keydown", this.handleKeyDown);
        }
        if (prevState.isRow !== this.state.isRow) {
            this.setState((prevState) => ({
                ...prevState,
                isRow: this.props.isRow,
            }));
        }
        if (prevProps.drawing !== this.props.drawing) {
            if ((this.props.drawing.currentDraw && this.props.drawing.currentDraw.status)) {
                this.onClearAll();
                this.setState(pre => ({
                    currentBetting: {
                        postGroup: [],
                        totalUsd: 0,
                        totalKhr: 0,
                    },
                    fields: {
                        betAmount: 0,
                        multiDigit: null,
                        numberFrom: "",
                        numberTo: "",
                        numberThree: "",
                        numberFour: "",
                    }
                }))
            }
        }
    }

    handleSelectChange = (name, value, callback) => {
        this.setState(prevState => ({
            ...prevState,
            [name]: value
        }), () => {
            callback && callback()
        });
    };


    /* removed event listener */
    removeListener = () => {
        window.removeEventListener("keydown", this.handleKeyDown);
        document.removeEventListener("visibilitychange", this.handleTabChange);
    };

    /* focus bet input */
    focusInputAmount() {
        this.setState({isFocus: true});
        const isMatrix = this.state.betTypes.activeBetTypeId === "MATRIX";
        switch (this.state.focusIndex) {
            case 1:
                this.twoDigitInput.current && this.twoDigitInput.current.focus();
                break;
            case 2:
                isMatrix
                    ? this.threeDigitInput.current && this.threeDigitInput.current.focus()
                    : this.amountDigitInput.current &&
                    this.amountDigitInput.current.focus();
                break;
            case 3:
                this.fourDigitInput.current && this.fourDigitInput.current.focus();
                break;
            case 4:
                this.amountDigitInput.current && this.amountDigitInput.current.focus();
                break;
            default:
                this.firstDigitInput.current && this.firstDigitInput.current.focus();
                break;
        }
    }

    /* unfocus bet input */
    unFocusInputAmount(isAll = false) {
        this.setState({isFocus: false});
        const isMatrix = this.state.betTypes.activeBetTypeId === "MATRIX";
        this.twoDigitInput.current && this.twoDigitInput.current.blur();
        this.threeDigitInput.current && this.threeDigitInput.current.blur();
        this.fourDigitInput.current && this.fourDigitInput.current.blur();
        this.amountDigitInput.current && this.amountDigitInput.current.blur();
        this.firstDigitInput.current && this.firstDigitInput.current.blur();
        if (isAll) {
            if (isMatrix) {
                this.firstDigitInput.current && this.firstDigitInput.current.blur();
                this.twoDigitInput.current && this.twoDigitInput.current.blur();
                this.threeDigitInput.current && this.threeDigitInput.current.blur();
                this.fourDigitInput.current && this.fourDigitInput.current.blur();
                this.amountDigitInput.current && this.amountDigitInput.current.blur();
            } else {
                this.firstDigitInput.current && this.firstDigitInput.current.blur();
                this.twoDigitInput.current && this.twoDigitInput.current.blur();
                this.amountDigitInput.current && this.amountDigitInput.current.blur();
            }
        }
    }

    /* handle edit post */
    onEditPost = (e) => {
        const item = e.postGroup;
        this.handlePostCheckChange("escape");
        let isLo = item.posts.includes("Lo");
        this.handlePostCheckChange(this.getPostEdited(item.posts));
        if (isLo) this.handlePostCheckChange("Lo");
        this.setState({postItemsTemp: e});
    };

    getPostEdited = (posts) => {
        let post = posts?.replaceAll("Lo", "").split("");
        if (post.filter(e => !isNaN(parseInt(e))).length) {
            post = post.filter(e => e !== "A");
            post = post.map((e => {
                if (e === "1")
                    e = "A1";
                if (e === "2")
                    e = "A2";
                if (e === "3")
                    e = "A3";
                if (e === "4")
                    e = "A4";
                return e;
            }));
        }
        return post;
    };

    /* handle on bet input change value  */
    onClickAmount = (p) => {
        let amount = this.state.fields.betAmount;
        if (amount === "") amount = 0;
        let betAmount = parseInt(amount);
        this.setState((prevState) => ({
            ...prevState,
            fields: {
                ...prevState.fields,
                betAmount: betAmount += p.value,
            },
        }));
    };

    /* handle on bet input change value  */
    onClickBetNumber = (value, isDelete) => {
        let {
            focusIndex, fields: {
                numberTo,
                numberFrom,
                betAmount
            }, isSelectFrom,
            isSelectTo, isBetAmount
        } = this.state;

        const getValue = (val) => isDelete ? val.toString().slice(0, -1) : `${val}`.concat(`${value}`);

        if (!numberTo || isSelectTo) numberTo = "";
        if (!numberFrom || isSelectFrom) numberFrom = "";
        if (!betAmount || isBetAmount) betAmount = "";

        if (focusIndex === 1) {
            numberTo.length < 3 &&
            this.setState(pre => ({
                fields: {
                    ...pre.fields,
                    numberTo: getValue(numberTo)
                },
                isSelectTo: false
            }));
        } else if (focusIndex === 4) {
            let amount = `${betAmount}`.concat(`${value}`);
            if (amount.length > 0 && parseInt(amount) === 0) return false;
            this.setState(pre => ({
                fields: {
                    ...pre.fields,
                    betAmount: getValue(betAmount)
                },
                isBetAmount: false
            }));
        } else {
            numberFrom.length < 3 &&
            this.setState(pre => ({
                fields: {
                    ...pre.fields,
                    numberFrom: getValue(numberFrom)
                },
                isSelectFrom: false
            }));
        }
    };

    onSubmitEditItem = (betItem) => {
        let {
            currentBetting: {postGroup}, tempItem, isLockBet
        } = this.state;
        if (isLockBet) {
            PNotify.info({
                title: this.props.t("messages:error"),
                text: this.props.t("messages:sale.error.results_are_coming_out"),
            });
            return false;
        }
        let postGroupItem = postGroup[tempItem.sectionNumber - 1];
        if (postGroupItem) {
            postGroupItem.items[tempItem.index] = betItem;
            postGroupItem.summaryAmount.betAmount -= tempItem.totalAmount;
            postGroupItem.summaryAmount.betAmount += betItem.totalAmount;
            this.setState({
                currentBetting: {...this.state.currentBetting}
            });
        }
    };
    getSelectedPost = () =>
        this.state.posts.filter((p) => p.checked).map((p) => p.id);


    /* validate edit post */
    handleSubmitPost = () => {

        let {postItemsTemp, currentBetting: {postGroup, totalUsd, totalKhr}} = this.state;
        const posts = this.getSelectedPost();

        if (posts.length === 0) {
            PNotify.info({
                title: this.props.t("messages:sale.error.title"),
                text: this.props.t("messages:sale.error.post_required"),
            });
            return false;
        }


        let postGroupItem = postGroup[postItemsTemp.index];
        postGroupItem.posts = posts.join("");
        let grandTotalKhr = 0;
        let grandTotalUsd = 0;


        postGroupItem.items.map((item) => {
            item.totalAmount = posts.length * item.betAmount * item.numberDetail.split(",").length;
            if (item.currencyCode === "KHR") grandTotalKhr += item.totalAmount;
            else grandTotalUsd += item.totalAmount;
            return item;
        });

        totalKhr -= postGroupItem.summaryAmount.totalKhr.betAmount;
        totalKhr += grandTotalKhr;
        totalUsd -= postGroupItem.summaryAmount.totalUsd.betAmount;
        totalUsd += grandTotalUsd;
        postGroupItem.summaryAmount.totalKhr.betAmount = grandTotalKhr;
        postGroupItem.summaryAmount.totalUsd.betAmount = grandTotalUsd;
        this.setState({
            currentBetting: {
                postGroup: postGroup,
                totalUsd, totalKhr
            }
        });
        this.onClearAll(true);
    };

    /* handle on double click bet item for edit*/
    onDoubleClick = (e, index) => {
        e.index = index;
        this.handlePostCheckChange("escape");
        this.setState({postItemsTemp: null}, () => this.onEditOrDelete(e));
    };

    /* handle on Edit bet item*/

    onEditItem = (e, index) => {
        e.index = index;
        this.handlePostCheckChange("escape");
        this.setState({postItemsTemp: null}, () => this.onEditOrDelete(e));
    };

    /* handle double click post for edit post */
    onDoubleClickPost = (item) => {
        this.handlePostCheckChange("escape");
        this.setState({tempItem: null}, () => this.onEditPost(item));
    };

    /* handle edit bet item */
    onEditOrDelete = (e) => {
        const setVal = (state) => this.setState(state);
        this.handleBetTypeCheckChange(
            e.betType === "MULTIPLE" ? "NORMAL" : e.betType
        );
        this.handlePostCheckChange("escape");
        let isLo = e.posts.includes("Lo");
        this.handlePostCheckChange(this.getPostEdited(e.posts));
        if (isLo) this.handlePostCheckChange("Lo");

        this.handleCurrencyCheckChange(e.currencyCode);
        if (e.numberThree) this.handleSpecBetCheckCheckChange("3D", true);

        setVal({selectedMulti: e.multiDigit > 0});

        this.setState((preState) => ({
            ...preState,
            tempItem: e,
            pairStatus: e.pairStatus,
            fields: {
                betAmount: e?.betAmount ?? 0,
                multiDigit: e?.multiDigit ?? "",
                numberFrom: e?.numberFrom ?? "",
                numberTo: e?.numberTo ?? "",
            },
        }));
        this.firstDigitInput.current.focus();
    };

    /* handle delete bet item */
    onDeleteItem(tempItem) {
        let {
            currentBetting: {postGroup},
        } = this.state;
        if (tempItem) {
            let postGroupItem = postGroup[tempItem.sectionNumber - 1];
            if (postGroupItem.items.length === 1) {
                postGroup.splice(tempItem.sectionNumber - 1, 1);
            } else {
                postGroupItem.items.splice(tempItem.index, 1);

            }
            postGroupItem.summaryAmount.betAmount -= tempItem.totalAmount;
            this.setState(
                {
                    currentBetting: {
                        postGroup: postGroup
                    }
                }
            );
            this.onClearAll();
        }

    }

    /* handle on bet input change value  */
    onInputChange = (event) => {
        const {name, value} = event.target;
        this.setState((prevState) => ({
            ...prevState,
            fields: {
                ...prevState.fields,
                [name]: value,
            },
        }));
    };

    /* get range number from number1 to number2 */
    getRangeNumbers = () => {
        const data = this.state;
        const {fields} = data;
        if (parseInt(fields.numberFrom) > parseInt(fields.numberTo)) {
            return [];
        }
        return getNormalRange(fields.numberFrom, fields.numberTo);
    };

    checkString = (string1, string2) => {
        let strs = string1.split("");
        let str2s = string2.split("");
        let valid = false;
        for (let i = 0; i < strs.length; i++) {
            if (strs[i] === str2s[i]) {
                valid = true;
            }
        }
        return valid;
    }

    checkStringPair = (str, lg = 1) => {
        return [...new Set(str.split(""))].length === lg;
    }


    /* validate enter bet */
    validateBetting = () => {
        const {
            fields,
            currency,
            betTypes: {activeBetTypeId}
        } = this.state;

        PNotify.removeAll();
        const fromLength = fields.numberFrom.length;
        const selectedPost = this.getSelectedPost();

        if (selectedPost.length === 0) {
            PNotify.info({
                title: this.props.t("messages:sale.error.title"),
                text: this.props.t("messages:sale.error.post_required"),
            });
            return false;
        }
        if (fields.betAmount <= 0) {
            PNotify.info({
                title: this.props.t("messages:sale.error.title"),
                text: this.props.t("messages:sale.error.bet_amount_required"),
            });
            return false;
        }
        if (currency === "KHR" && fields.betAmount < 100) {
            PNotify.info({
                title: this.props.t("messages:sale.error.title"),
                text: this.props.t("messages:sale.error.bet_amount_min_required"),
            });
            return false;
        }
        if (
            currency === "KHR" &&
            parseFloat(fields.betAmount) % 100 !== 0
        ) {
            PNotify.info({
                title: this.props.t("messages:sale.error.title"),
                text: this.props.t("messages:sale.error.bet_amount_in_valid"),
            });
            return false;
        }

        if (fromLength < 2) {
            PNotify.info({
                title: this.props.t("messages:sale.error.title"),
                text: this.props.t(
                    "messages:sale.error.number_bet_must_be_greater_than"
                ),
            });
            return false;
        }
        if (fromLength > 3) {
            PNotify.info({
                title: this.props.t("messages:sale.error.title"),
                text: this.props.t("messages:sale.error.bet_number_invalid"),
            });
            return false;
        }
        const from = fields.numberFrom;
        const to = fields.numberTo;

        let isPair = this.checkStringPair(from) && this.checkStringPair(to);

        if (activeBetTypeId === "SPECIAL_RANGE") {
            if (!isPair && !this.checkString(from, to)) {
                PNotify.info({
                    title: this.props.t("messages:sale.error.title"),
                    text: this.props.t("messages:sale.error.special_range_invalid"),
                });
                return false;
            }
        }

        switch (activeBetTypeId) {
            case "RANGE":
            case "SPECIAL_RANGE":

                if (from.length !== to.length) {
                    PNotify.info({
                        title: this.props.t("messages:sale.error.title"),
                        text: this.props.t("messages:sale.error.bet_number_must_be_the_same_length"),
                    });
                    return false;
                }

                if (parseInt(from) - parseInt(to) === 0) {
                    PNotify.info({
                        title: this.props.t("messages:sale.error.title"),
                        text: this.props.t("messages:sale.error.bet_number_cannot_the_same"),
                    });
                    return false;
                }
                if (parseInt(from) - parseInt(to) > 0) {
                    PNotify.info({
                        title: this.props.t("messages:sale.error.title"),
                        text: this.props.t("messages:sale.error.bet_from_number_must_be_less_than"),
                    });
                    return false;
                }
                break;
            default:
        }
        return true;
    };

    /* get change on digit for SPECIAL_RANGE */
    setIsDigit = (type) => {
        const {fields} = this.state;
        if (type === "SPECIAL_RANGE") {
            let diffIndex = [];
            const from = fields.numberFrom.split("");
            const to = fields.numberTo.split("");
            from.forEach((item, i) => {
                diffIndex.push(item !== to[i]);
            });
            if (diffIndex.length > 0) {
                return diffIndex;
            }
            return [false, false, false, false];
        } else {
            return [false, false, false, false];
        }
    };

    /* handle bet item by enter */
    handleSubmitEnter = (isValidate = true, isSubmit = false, autoPrint = false, isMobile = false) => {
        const {
            t
        } = this.props;
        if (!this.validateBetting()) {
            return null;
        }
        const data = this.state;
        let {
            isLockBet,
            fields,
            tempItem,
            pairStatus,
            selectedMulti,
            filters: {currentTicket},
            currentBetting: {postGroup},
        } = data;

        let betItems = postGroup.map(e => {
            return e.items;
        });
        const merged = [].concat.apply([], betItems);
        if (merged.length > 49) {
            PNotify.info({
                title: this.props.t("messages:error"),
                text: this.props.t("messages:sale.error.error_limit_amount"),
            });
            return false;
        }

        const posts = this.getSelectedPost();
        let betType = data.betTypes.activeBetTypeId;
        let betTitle = betType;
        let numbers = [];
        let numberConfirm = [];
        let titles = [];
        const {numberFrom, numberTo} = fields;
        let fromLength = numberFrom.length;
        const isDigit = this.setIsDigit(betType);

        switch (betType) {
            case "RANGE":
                numbers = this.getRangeNumbers();
                break;
            case "SPECIAL_RANGE":
                if (
                    selectedMulti &&
                    this.checkStringPair(numberFrom) &&
                    this.checkStringPair(numberTo) && fromLength > 2
                )
                    numbers = specialTripleX(numberFrom, numberTo);
                else numbers = getSpecialRange(numberFrom, numberTo);

                if (numbers.length === 0) {
                    PNotify.info({
                        title: this.props.t("messages:sale.error.title"),
                        text: this.props.t("messages:sale.error.special_range_invalid"),
                    });
                    return false;
                }
                isDigit.forEach((digit, index) => {
                    if (digit) {
                        titles.push("J" + (index + 1));
                    }
                });
                if (titles.length > 0) {
                    betTitle += "_" + titles.join("_");
                }
                break;
            default:
                // NORMAL
                numbers = [numberFrom];
                break;
        }
        if (pairStatus === 1) numbers = getPair(numbers);
        if (pairStatus === 2) numbers = getNotPair(numbers);
        if (selectedMulti) {
            numberConfirm = numbers;
            if (!(this.checkStringPair(numberFrom) &&
                this.checkStringPair(numberTo) && fromLength > 2)) {
                fields.multiDigit = numberFrom.length;
                if (numbers.length > 0) {
                    numberConfirm = [];
                    numbers.forEach((number) => {
                        const multiNumber = getMulti(number, fields.multiDigit);
                        numberConfirm.push(...multiNumber);
                    });
                    numberConfirm = [...new Set(numberConfirm)];
                }
            } else fields.multiDigit = numberFrom.length;

            let types = ["RANGE", "SPECIAL_RANGE"];
            if (types.includes(betType))
                betTitle += "_MULTIPLE";
            else {
                betTitle = "MULTIPLE";
                betType = "MULTIPLE";
            }
            if (betType === "SPECIAL_RANGE" && titles.length > 1 && numberFrom.length === 2) {
                if (numberFrom.length === titles.length) {
                    betTitle = betTitle.replace("_MULTIPLE", "");
                    fields.numberMulti = null;
                }
            }

        } else
            numberConfirm = numbers;
        let betAmount = parseFloat(fields.betAmount);
        let totalAmount = numberConfirm.length * this.getSelectedPost().length * betAmount;
        let postString = posts.join("");
        let sectionNumber = currentTicket;
        if (_.isEmpty(numberConfirm)) {
            PNotify.info({
                title: this.props.t("messages:sale.error.title"),
                text: this.props.t("messages:sale.error.bet_number_invalid"),
            });
            return false;
        }

        if (numberConfirm.length > 100) {
            PNotify.info({
                title: this.props.t("messages:error"),
                text: this.props.t("messages:sale.error.error_limit_number"),
            });
            return false;
        } else {
            if (!selectedMulti) fields.multiDigit = null
            else fields.multiDigit = fields.numberFrom.length
        }
        if (numberConfirm.length > 10 && isValidate) {
            this.setState({isFocus: false});
            swal({
                title: this.props.t("messages:confirm.are_you_sure"),
                text: this.props.t("messages:confirm.continue_betting"),
                icon: "warning",
                buttons: [t("buttons:no"), t("buttons:yes")],
                successMode: true,
            }).then((value) => {
                if (value) {
                    this.handleSubmitEnter(false, isMobile)
                } else return false;
            });
            return false;
        }
        const betRQ = new BetRQ({
            posts: posts.join(""),
            betType: betType,
            betTitle: betTitle,
            sectionNumber: sectionNumber,
            currencyCode: data.currency,
            multiDigit: fields.multiDigit,
            numberFrom: fields.numberFrom,
            numberTo: fields.numberTo ?? "",
            betAmount: betAmount,
            numberDetail: numberConfirm.join(","),
            numberQuantity: numberConfirm.length,
            totalAmount: totalAmount,
            pairStatus: pairStatus,
        });

        if (tempItem) {
            betRQ.sectionNumber = tempItem.sectionNumber;
            this.onSubmitEditItem(betRQ);
            this.onClearAll();
            return false;
        } else if (isLockBet) {
            PNotify.info({
                title: this.props.t("messages:error"),
                text: this.props.t("messages:sale.error.results_are_coming_out"),
            });
            return false;
        }

        let selectedPost =
            currentTicket > postGroup.length ? "" : this.findGroupPost(postString, currentTicket);
        if (selectedPost !== "") {
            selectedPost.items.push(betRQ);
            selectedPost.summaryAmount.betAmount += totalAmount;
        } else {
            betRQ.sectionNumber = postGroup.length > 0 ? postGroup.length + 1 : 1;
            postGroup.push({
                posts: postString,
                summaryAmount: {
                    betAmount: totalAmount,
                },
                items: [betRQ],
            });
        }

        if (isSubmit) this.handleSubmitBetting(autoPrint, postGroup)
        else this.setState({
            currentBetting: {
                ...this.state.currentBetting,
                postGroup: postGroup,
            },
            fields: {
                ...fields,
                numberFrom: "",
                multiDigit: null,
            },
        });
        this.firstDigitInput.current.focus();
        let elem = document.getElementById('betting-item');
        if (elem) elem.scrollTop = elem.scrollHeight;
        this.handleSelectChange("currentTicket", postGroup.length > 0 ? postGroup.length : 1);

    };

    /* delete all betting items */
    onClearBetItem = () => {
        const {t} = this.props;
        swal({
            title: t("messages:confirm.are_you_sure"),
            text: t("messages:confirm.clear_current_bet"),
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((value) => {
            if (value)
                this.setState({
                    currentBetting: {
                        postGroup: [],
                        totalUsd: 0,
                        totalKhr: 0
                    },
                });
        });
    };

    onClearItem = () => {
        const {t} = this.props;
        swal({
            title: t("messages:confirm.are_you_sure"),
            text: t("messages:confirm.clear_current_bet"),
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((value) => {
            if (value)
                this.setState({
                    currentBetting: {
                        postGroup: [],
                    },
                });
        });
    };

    /* handle submit betting */

    handleSubmitBetting = (autoPrint, pg = [], isMobile = false) => {

        let {currentBetting: {postGroup}, isBetting} = this.state;

        if (postGroup.length === 0) {
            this.handleSubmitEnter(true, true, autoPrint, isMobile);
            return false;
        }

        if (isBetting) return null;
        const {
            postBetting,
            drawing,
            recentTicket: {filter}
        } = this.props;

        if (postGroup.length === 0)
            postGroup = pg;
        if (postGroup.length > 0 && drawing.currentDraw.drawCode) {
            let betting = [];
            postGroup.forEach((item) => {
                betting.push(...item.items);
            });
            this.setState({isBetting: true});
            postBetting({
                drawCode: drawing?.currentDraw.drawCode,
                items: betting,
            }).then(async (lane) => {
                this.setState({
                    currentBetting: {
                        postGroup: [],
                        totalUsd: 0,
                        totalKhr: 0
                    },
                });
                this.setState(pre => ({
                    ...pre,
                    fields: {
                        ...pre.fields,
                        betAmount: 0
                    }
                }))
                this.setState({isBetting: false});
                this.props.fetchUserBalance();
                this.props.fetchLotto5dRecentTicket({...filter});
                PNotify.removeAll();
                PNotify.success({
                    title: this.props.t("messages:success"),
                    text: this.props.t("messages:sale.success"),
                });
                autoPrint && this.printTicket(lane);
                this.handleSelectChange("currentTicket", 1);
                this.onClearAll();
            }).catch(error => {
                console.log("error=======>");
                this.setState({isBetting: false});
                error && showErrorMessage(error, this.props.t);
                this.props.setLoading(ERROR_LOADING)
            });
        }
    };

    printTicket = (lane) => {
        this.setState({ticket: lane.ticket}, () => {
            this.state.ticket && document.getElementById("print_btn").click();
        });
    };

    renderTicket = () => {

        const {ticket} = this.state;
        return <div style={{display: 'none'}}>
            <div>
                <Ticket58 lotteryType="LO5D" ref={el => (this.componentRef = el)}
                          object={ticket} {...this.props}/>
            </div>
            <ReactToPrint
                copyStyles={true}
                onAfterPrint={() => {
                    this.setState({ticket: null});
                    this.props.fetchCurrentDraw5D();
                    this.firstDigitInput.current.focus();
                }}
                trigger={() => {
                    return <button id="print_btn" className='bg-transparent border-0'>
                    </button>;
                }}
                content={() => this.componentRef}
            />
        </div>
    };


    /* Searching for same post group for update bet item*/
    findGroupPost = (posts, currentTicket) => {
        const {
            currentBetting: {postGroup}
        } = this.state;

        if (currentTicket < postGroup.length) {
            if (postGroup.length > 0) {
                const lastPost = postGroup[currentTicket - 1];
                return lastPost.posts === posts ? lastPost : "";
            }
        } else {
            if (postGroup.length > 0) {
                const lastPost = postGroup[postGroup.length - 1];
                return lastPost.posts === posts ? lastPost : "";
            }
        }
        return "";
    };

    /* handle remove last bet item form betting board */
    deleteLastBet = () => {
        let {
            currentBetting: {postGroup, totalKhr, totalUsd, ...currentBetting},
        } = this.state;
        if (postGroup.length > 0) {
            const lastGroup = postGroup[postGroup.length - 1];
            if (lastGroup.items.length === 1) {
                postGroup.pop();
                const item = lastGroup.items[0];
                this.setState(
                    {
                        currentBetting: {
                            ...currentBetting,
                            postGroup: postGroup,
                        },
                    },
                    () => this.handleSelectChange("currentTicket", postGroup.length > 0 ? postGroup.length : 1)
                );
                if (item.currencyCode === "KHR")
                    totalKhr -= item.totalAmount;
                else totalUsd -= item.totalAmount;
                this.setState({
                    currentBetting: {...this.state.currentBetting, totalUsd, totalKhr}
                });
                return null;
            }
            if (lastGroup.items.length > 1) {
                const remove = lastGroup.items.pop();
                if (remove.currencyCode === "KHR") {
                    lastGroup.summaryAmount.totalKhr.betAmount -= remove.totalAmount;
                } else {
                    lastGroup.summaryAmount.totalUsd.betAmount -= remove.totalAmount;
                }
                postGroup[postGroup.length - 1] = lastGroup;
                if (remove.currencyCode === "KHR")
                    totalKhr -= remove.totalAmount;
                else totalUsd -= remove.totalAmount;

                this.setState(
                    {
                        currentBetting: {
                            postGroup: postGroup,
                            totalUsd,
                            totalKhr
                        },
                    },
                    () => this.handleSelectChange("currentTicket", postGroup.length > 0 ? postGroup.length : 1));
            } else {
                postGroup.pop();
                this.setState({
                    currentBetting: {
                        ...currentBetting,
                        postGroup: postGroup,
                    },
                });
            }

            this.setState({
                currentBetting: {...this.state.currentBetting, totalUsd, totalKhr}
            });
        }
    };


    /* handle on changed bet type */
    handleBetTypeCheckChange(betType) {
        const betTypes = this.state.betTypes;
        betTypes.activeBetTypeId = betType;
        this.setState({
            betTypes,
            focusIndex: 0,
        });
        if (this.state.isFocus) this.firstDigitInput.current && this.firstDigitInput.current.focus();
        if (betType === "MATRIX") {
            this.setState({specBetCheck: null});
        }
    }

    /* handle multiple check */
    handleMultipleCheckChange = () => {
        this.setState(pre => ({
            ...pre,
            selectedMulti: !pre.selectedMulti
        }));
    };

    /* handle change post */
    handlePostCheckChange(name, isClear = false) {
        if (this.state.tempItem) return false;
        let posts = this.state.posts.map((p) => {
            if (name === "all") {
                return Object.assign({}, p, {
                    checked: this.getSelectedPost().length < 4 ? true : !p.checked
                });
            } else if (p.id === name || name.indexOf(p.id) !== -1) {
                return Object.assign({}, p, {
                    checked: isClear ? true : !p.checked,
                });
            } else if (name === "escape" || isClear)
                return Object.assign({}, p, {
                    checked: false,
                });
            return p;
        });

        this.setState({posts: posts});
    }

    /* handle change currency KHR/USD */
    handleCurrencyCheckChange(value) {
        this.setState({
            currency: value,
        });
    }

    /* handle change checkbox special bet */
    handleSpecBetCheckCheckChange(value, isClear = false) {
        this.setState({
            specBetCheck:
                value === this.state.specBetCheck && !isClear ? null : value,
        });
    }


    /* clear betting board */
    onClearAll = (isEdit = false) => {
        this.handlePostCheckChange("escape");
        this.handleBetTypeCheckChange("NORMAL", isEdit);
        this.setState((prevState) => ({
            ...prevState,
            focusIndex: 0,
            selectedMulti: false,
            tempItem: null,
            postItemsTemp: null,
            fields: {
                ...prevState.fields,
                multiDigit: null,
                numberFrom: "",
                numberTo: ""
            },
        }));
        const nums = this.state.currentBetting.postGroup.length;
        this.handleSelectChange("currentTicket", nums > 0 ? nums : 1);
        return null;
    };

    resetBet = () => {
        this.onClearAll();
        this.setState(pre => ({
            ...pre,
            fields: {
                ...pre.fields,
                betAmount: 0
            }
        }));
    };

    /* handle key shortcut */
    handleKeyDown(e) {
        const filters = this.state.filters;
        const graveKey = this.state.graveKey;
        this.setState({graveKey: e.keyCode === KEY_CODE.grave_accent});

        /* increase currentTicket */
        if (e.keyCode === KEY_CODE.right_arrow) {
            e.preventDefault();
            this.handleSelectChange("currentTicket", filters.currentTicket + 1);
            return null;
        }

        /* clear current betting */
        if (
            e.keyCode === KEY_CODE.escape ||
            (e.shiftKey && e.keyCode === KEY_CODE.delete)
        ) {
            e.preventDefault();
            this.resetBet()

        }
        const {isFocus} = this.state;
        const {isEdit} = this.props;

        /* focus & blur input */
        if (e.keyCode === KEY_CODE.space) {
            e.preventDefault();
            if (!isFocus) {
                this.focusInputAmount();
            } else this.unFocusInputAmount();
            this.setState((prevState) => ({
                ...prevState,
                isFocus: !isFocus,
            }));
            return null;
        }
        if (isFocus && !isEdit) {
            switch (true) {
                /* submit current betting */
                case e.keyCode === KEY_CODE.left_arrow: {
                    e.preventDefault();
                    this.handleSubmitBetting(this.state.autoPrint);
                    break;
                }
                /* enter betting item */
                case e.keyCode === KEY_CODE.enter: {
                    e.preventDefault();
                    this.handleSubmitEnter();
                    break;
                }

                // /*change currency*/
                // case e.keyCode === KEY_CODE.subtract: {
                //     e.preventDefault();
                //     this.handleCurrencyCheckChange(
                //         this.state.currency === "USD" ? "KHR" : "USD"
                //     );
                //     break;
                // }

                /*key delete to remove last bet*/
                case e.keyCode === KEY_CODE.delete:
                    e.preventDefault();
                    this.deleteLastBet();
                    break;

                /*multi post select*/
                case e.shiftKey &&
                (e.keyCode === KEY_CODE["1"] || e.keyCode === KEY_CODE.f1 || e.keyCode === KEY_CODE.numpad1): {
                    e.preventDefault();
                    this.handlePostCheckChange("A");
                    break;
                }

                case (graveKey || e.shiftKey) &&
                (e.keyCode === KEY_CODE["2"] || e.keyCode === KEY_CODE.f2 || e.keyCode === KEY_CODE.numpad2): {
                    e.preventDefault();
                    this.handlePostCheckChange(["A", "B"]);
                    break;
                }

                case (graveKey || e.shiftKey) &&
                (e.keyCode === KEY_CODE["3"] || e.keyCode === KEY_CODE.f3 || e.keyCode === KEY_CODE.numpad3): {
                    e.preventDefault();
                    this.handlePostCheckChange(["A", "B", "C"]);
                    break;
                }

                case (graveKey || e.shiftKey) &&
                (e.keyCode === KEY_CODE["4"] || e.keyCode === KEY_CODE.f4 || e.keyCode === KEY_CODE.numpad4): {
                    e.preventDefault();
                    this.handlePostCheckChange(["A", "B", "C", "D"]);
                    break;
                }



                /*all post*/
                case (graveKey || e.shiftKey) && (e.keyCode === KEY_CODE["9"] || e.keyCode === KEY_CODE.numpad9): {
                    e.preventDefault();
                    this.handlePostCheckChange(["A", "B", "C", "D"]);
                    break;
                }

                case e.keyCode === KEY_CODE.insert: {
                    e.preventDefault();
                    this.handlePostCheckChange(["A", "B"]);
                    break;
                }

                case e.keyCode === KEY_CODE.end: {
                    e.preventDefault();
                    this.handlePostCheckChange(["B", "C", "D"]);
                    break;
                }

                case e.keyCode === KEY_CODE.page_down: {
                    e.preventDefault();
                    this.handlePostCheckChange(["A", "B", "C", "D"]);
                    break;
                }


                case e.keyCode === KEY_CODE.f11: {
                    e.preventDefault();
                    this.handlePostCheckChange("all");
                    break;
                }

                /*single post select*/
                case e.keyCode === KEY_CODE.f1: {
                    e.preventDefault();
                    this.handlePostCheckChange("A");
                    break;
                }

                case e.keyCode === KEY_CODE.f2: {
                    e.preventDefault();
                    this.handlePostCheckChange("B");
                    break;
                }

                case e.keyCode === KEY_CODE.f3: {
                    e.preventDefault();
                    this.handlePostCheckChange("C");
                    break;
                }

                case e.keyCode === KEY_CODE.f4: {
                    e.preventDefault();
                    this.handlePostCheckChange("D");
                    break;
                }


                /*change betType to next*/
                case e.keyCode === KEY_CODE.divide: {
                    e.preventDefault();
                    let betTypeIndex = this.state.betTypes.betType.findIndex(
                        (b) => b.id === this.state.betTypes.activeBetTypeId
                    );
                    if (betTypeIndex === this.state.betTypes.betType.length - 1)
                        betTypeIndex = 0;
                    else betTypeIndex++;
                    this.handleBetTypeCheckChange(
                        this.state.betTypes.betType[betTypeIndex].id
                    );
                    break;
                }

                /*change betType to next*/
                case e.keyCode === KEY_CODE.multiply: {
                    e.preventDefault();
                    this.handleMultipleCheckChange();
                    break;
                }

                /*change betType by Char*/
                case e.keyCode === KEY_CODE.a: {
                    e.preventDefault();
                    this.handleBetTypeCheckChange("NORMAL");
                    break;
                }
                case e.keyCode === KEY_CODE.s: {
                    e.preventDefault();
                    this.handleBetTypeCheckChange("RANGE");
                    break;
                }
                case e.keyCode === KEY_CODE.d: {
                    e.preventDefault();
                    this.handleBetTypeCheckChange("SPECIAL_RANGE");
                    break;
                }

//                 case e.keyCode === KEY_CODE.g: {
//                     e.preventDefault();
//                     this.setState((preState) => ({
//                         ...preState,
//                         pairStatus: preState.pairStatus === 2 ? 0 : 2
//                     }));
//                     break;
//                 }

                /*multiply*/
                case e.keyCode === KEY_CODE.x: {
                    e.preventDefault();
                    this.handleMultipleCheckChange();
                    break;
                }

                default: {
                    return;
                }
            }
        }
        this.setState({graveKey: e.keyCode === KEY_CODE.grave_accent});
    }

    /* handle key press on bet input */
    handleDigitKeyPress(e) {
        if (e.keyCode === KEY_CODE.add || e.keyCode === KEY_CODE.tab) {
            e.preventDefault();
            const length = 2;
            const form = e.target.form;
            let els = Array.from(form.elements).filter(e => e.type === "text");
            const index =
                Array.prototype.indexOf.call(form, e.target) === length
                    ? -1
                    : Array.prototype.indexOf.call(form, e.target);
            if (els[index + 1]) els[index + 1].focus();
            else els[0].focus();
        }
    }

    playSound = (src) => {
        const {audio} = this.props;
        if (audio && !audio.isMute) playAudio(src);
    }

    setFilter = state => this.setState(state);

    /* render Context betting board */
    render() {
        const contextValue = {
            ...this.state,
            ...this.props,
            focusInputAmount: this.focusInputAmount,
            unFocusInputAmount: this.unFocusInputAmount,
            onEditPost: this.onEditPost,
            getPostEdited: this.getPostEdited,
            onClickAmount: this.onClickAmount,
            onClickBetNumber: this.onClickBetNumber,
            onSubmitEditItem: this.onSubmitEditItem,
            getSelectedPost: this.getSelectedPost,
            handleSubmitPost: this.handleSubmitPost,
            onDoubleClick: this.onDoubleClick,
            onEditItem: this.onEditItem,
            onDoubleClickPost: this.onDoubleClickPost,
            onEditOrDelete: this.onEditOrDelete,
            onDeleteItem: this.onDeleteItem,
            onInputChange: this.onInputChange,
            getRangeNumbers: this.getRangeNumbers,
            checkString: this.checkString,
            checkStringPair: this.checkStringPair,
            validateBetting: this.validateBetting,
            setIsDigit: this.setIsDigit,
            handleSubmitEnter: this.handleSubmitEnter,
            onClearBetItem: this.onClearBetItem,
            onClearItem: this.onClearItem,
            handleSubmitBetting: this.handleSubmitBetting,
            printTicket: this.printTicket,
            renderTicket: this.renderTicket,
            findGroupPost: this.findGroupPost,
            deleteLastBet: this.deleteLastBet,
            handleBetTypeCheckChange: this.handleBetTypeCheckChange,
            handleMultipleCheckChange: this.handleMultipleCheckChange,
            handlePostCheckChange: this.handlePostCheckChange,
            handleCurrencyCheckChange: this.handleCurrencyCheckChange,
            handleSpecBetCheckCheckChange: this.handleSpecBetCheckCheckChange,
            onClearAll: this.onClearAll,
            resetBet: this.resetBet,
            handleKeyDown: this.handleKeyDown,
            handleDigitKeyPress: this.handleDigitKeyPress,
            setFilter: this.setFilter,
            playSound: this.playSound,
            firstDigitInput: this.firstDigitInput,
            twoDigitInput: this.twoDigitInput,
            threeDigitInput: this.threeDigitInput,
            fourDigitInput: this.fourDigitInput,
            amountDigitInput: this.amountDigitInput,
            componentRef: this.componentRef
        }

        return (
            <Lotto5dContext.Provider value={contextValue}>
                {this.props.children}
            </Lotto5dContext.Provider>
        );
    }

}

const mapStateToProps = state => ({
    sale: state.lotto5d.sale,
    pages: state.lotto5d.page,
    user: state.user,
    config: state.config,
    drawing: state.lotto5d.drawing.data,
    results: state.lotto5d.result,
    audio: state.audio,
    recentTicket: state.lotto5d.recentTicket
});


export default connect(mapStateToProps,
    {
        fetchCurrentDraw5D,
        fetchBetting,
        postBetting,
        updateBet,
        fetchPaging,
        fetchResults,
        fetchUserBalance,
        setLoading,
        fetchLotto5dRecentTicket
    })(withTranslation()(MainDrawingWrapper));
